export default __webpack_public_path__ + "static/media/cheese-cake.b8f255ae.jpg";